export const formatDate = (dateString) => {
    if (!dateString) return '-';
    // Si la fecha ya viene en formato DD/MM/YYYY la retornamos directo
    if (dateString.includes('/')) return dateString;

    const parts = dateString.split('-');
    if (parts.length === 3) {
        return `${parts[2]}/${parts[1]}/${parts[0]}`;
    }
    return dateString;
};

/**
 * Formatea un número como moneda en pesos argentinos o dólares (U$S 1.500.000,25 / $ 1.500.000,25)
 */
export const formatCurrency = (amount, currency = 'ARS') => {
    const num = parseFloat(amount) || 0;
    
    const formattedNumber = num.toLocaleString('es-AR', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
    });

    const symbol = (currency === 'USD' || currency === 'U$S') ? 'U$S' : '$';

    return `${symbol} ${formattedNumber}`;
};

/**
 * Formatea un número o valor a string para un input de formulario (1.500.000,25)
 */
export const formatNumberToInput = (val) => {
    if (val === undefined || val === null || val === '') return '';
    const num = sanitizeAmount(val);
    if (num === 0) return '';
    return num.toLocaleString('es-AR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
};

/**
 * Filtra un string dejando únicamente caracteres numéricos (0-9)
 */
export const onlyNumbers = (val) => {
    if (!val) return '';
    return String(val).replace(/\D/g, '');
};

/**
 * Normaliza y limpia un string numérico ingresado por el usuario devolviendo un float utilizable
 */
export const sanitizeAmount = (val) => {
    if (val === undefined || val === null || val === '') return 0;
    if (typeof val === 'number') return isNaN(val) ? 0 : val;
    
    let clean = String(val).replace(/[^\d.,]/g, '');

    if (clean.includes(',') && clean.includes('.')) {
        clean = clean.replace(/\./g, '').replace(',', '.');
    } else if (clean.includes(',')) {
        clean = clean.replace(',', '.');
    }

    const num = parseFloat(clean);
    return isNaN(num) ? 0 : num;
};

/**
 * Devuelve la clase de estilo Badge según el estatus de una factura o gasto
 */
export const getStatusBadgeStyle = (estatus) => {
    switch (estatus) {
        case 'Cobrada':
        case 'Pagado':
            // Verde: Completado / Éxito
            return 'bg-emerald-50 text-emerald-700 border-emerald-200';
            
        case 'Pendiente de Cobro':
        case 'Pendiente de Pago':
        case 'Programado':
            // Ámbar / Amarillo: Pendiente estándar
            return 'bg-amber-50 text-amber-700 border-amber-200';
            
        case 'Parcialmente Pagado':
        case 'Parcialmente Cobrado':
            // Azul / Celeste: En progreso / Pago parcial
            return 'bg-blue-50 text-blue-700 border-blue-200';
            
        case 'Anulada':
            // Gris / Pizarra: Inactivo / Cancelado
            return 'bg-slate-100 text-slate-600 border-slate-200';
            
        case 'Vencida':
        case 'Vencido':
            // Rojo: Alerta / Vencido
            return 'bg-rose-50 text-rose-700 border-rose-200';

        default:
            return 'bg-slate-50 text-slate-600 border-slate-200';
    }
};

/**
 * Obtiene el período actual en formato MM/YYYY
 */
export const getCurrentPeriod = () => {
    const date = new Date();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    return `${month}/${year}`;
};